<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="academicLevelSummary">
			<title-bar title="Niveles escolares" :percentage="academicLevelSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="academicLevelSummary.itemName" :percentage="academicLevelSummary.itemPercentage" percentageTitle="Promedio Nivel"/>
			<div class="col">
				<div class="row between innerRubric">
				<percentages-summary v-for="coachingCategory in academicLevelSummary.coachingCategories" :key="coachingCategory.id" :coachingCategory="coachingCategory"></percentages-summary>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import mediator from '@/mediator';
export default {
	props: ['academicLevelId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		academicLevelSummary () {
			if (this.$store.state.academicLevels.summary) return this.$store.state.academicLevels.summary.find((item) => {
				return item.itemId == this.academicLevelId;
			});
			else return this.$store.state.academicLevels.summary;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/academicLevels/summary.vue